const speakersList = [
	{
		name: 'Dan Nistor',
		role: 'Co-Founder & CEO at Vevol Media',
		image: 'dan-nistor',
		topic: 'Event Host',
	},
	{
		name: 'Bogdan Dogaru',
		role: 'Co-Founder & CTO at Vevol Media',
		image: 'bogdan-dogaru',
		topic: 'Keynote Speaker',
	},
	{
		name: 'Stefan Chiriacescu',
		role: 'Founder and CEO at Ecommerce Today',
		image: 'stefan-chiriacescu',
		topic: 'Keynote Speaker',
	},
	{
		name: 'Catalin Ciochina',
		role: 'Co-Founder and CEO at xConnector',
		image: 'catalin-ciochina',
		topic: 'Keynote Speaker',
	},
	{
		name: 'Maurice Junghans',
		role: 'Senior Account Executive DACH/EE at Shopify',
		image: 'maurice-junghans',
		topic: 'Keynote Speaker',
	},
	{
		name: 'Andrew Cargill',
		role: 'Founder & CEO at Zapiet',
		image: 'andrew-cargill',
		topic: 'Keynote Speaker',
	},
	{
		name: 'Ruben Bristian',
		role: 'Co-Founder & CEO at Krown Themes',
		image: 'ruben-bristian',
		topic: 'Co-Organiser',
	},
];

export default speakersList;
